import styled from 'styled-components';
import { H1, P } from '../elements/Text';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 720px; // we use 820 in intro and outro
  margin: 0 auto;
  margin-top: 72px;
  padding-bottom: 72px;
  height: 100%;
`;

export default function TestTimeout() {
  return (
    <Wrapper>
      <H1 style={{ marginTop: 32 }}>Time's up - well done!</H1>
      <P>
        The assessment time limit has been reached. Nice work getting through as
        much as you could.
      </P>
      <P>
        <b>
          We have saved all your answers and will use them to assess your
          results.
        </b>
      </P>
      <P>
        Our team will review your responses and get in touch soon with your
        results and recommended next steps.
      </P>
    </Wrapper>
  );
}
